import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Stream from 'flarum/utils/Stream';
import Button from 'flarum/components/Button';

import selectButton from "../../common/util/selectButton";
import UserSubmitType1Component from "../UserSubmitType1Component";
import InfoManagementComponent from "../InfoManagementComponent";
import QueryManagementComponent from "../QueryManagementComponent";
import SiteInfoYouKePlanModal from './SiteInfoYouKePlanModal';

export default class UserSubmitModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    this.wrapData = this.attrs.wrapData || null;
    this.editMode = this.attrs.editMode || false;
    const _this = this;

    if(this.wrapData===null){
      this.from = this.attrs.from || null;
      this.selectedType = null;
      this.viewType = "normal";
      this.targetData = null;
      this.wrapData = {initType:"add",from:this.from};
      this.editMode = true;
    }else{
      this.from = this.wrapData.from;
      this.selectedType = this.wrapData.selectedType;
      this.viewType = this.wrapData.viewType || "normal";
      this.targetData = this.wrapData.targetData || null;
      this.targetDetailsData = this.wrapData.targetDetailsData;
    }

    this.wrapData.returnModal = "UserSubmitModal";
    
    $(window).off("u2diEditModeDisabled").on("u2diEditModeDisabled",function(e){
      _this.editMode = false;
      m.redraw();
    })
  }

  oncreate(vnode){
    super.oncreate(vnode);
  }

  className() {
    return 'Modal--medium';
  }

  title() {
    return [];
  }

  content() {
    const _this = this;
    const editMode = this.editMode;
    let wrapData = this.wrapData;
    wrapData.selectedType = this.selectedType;

    let button0ClassName = "u2diSelectionButton ";
    let button1ClassName = "u2diSelectionButton ";
    if(this.selectedType==="tdwz"){
      button0ClassName+="u2diSelectionButtonSelected";
    }else if(this.selectedType==="jzwz"){
      button1ClassName+="u2diSelectionButtonSelected";
    }

    let sn,views,distributes,queries;

    if(this.targetData){
      const infoBaseData = this.targetData.data.type==="u2diInfoBase"?this.targetData:this.targetData.u2diBaseData();
      sn = infoBaseData.sn();
      views = infoBaseData.views();
      distributes = infoBaseData.distributes();
      queries = infoBaseData.queries();
    }

    const u2diUserType0 = app.forum.attribute('u2diUserType0');
    const u2diUserType9 = app.forum.attribute('u2diUserType9');
    const showEditButton = this.editMode===false && u2diUserType9===true;

    return [
      <div className="Modal-body u2diSubmitModalBody">
        <div className="Form-group">

          {this.targetData && (
            <div style="text-align: center;">
              <div className="u2diInfoMagementHeader" style="position: relative;">
                <span className="u2diInfoManagementSN">
                  {sn}
                </span>
              </div>
              <div className="u2diInfoMagementInfos">
                {app.translator.trans('ziven-u2di.forum.item-management-info',{views:views,distributes:distributes,queries:queries})}
              </div>
            </div>
          )}

          {this.viewType==="normal" && (
            <div style="text-align:center">
              <div group="userSubmitionTypes" className={button0ClassName} onclick={(e) => selectButton(e,"u2diSelectionButtonSelected",function(){
                $(".u2diInputError").removeClass("u2diInputError");
                _this.showComponent("tdwz");
              })}>
                {app.translator.trans('ziven-u2di.forum.user-submission-option-tdwz')}
              </div>
              <div group="userSubmitionTypes" className={button1ClassName} style="margin-left: 3px;" onclick={(e) => selectButton(e,"u2diSelectionButtonSelected",function(){
                $(".u2diInputError").removeClass("u2diInputError");
                _this.showComponent("jzwz");
              })}>
                {app.translator.trans('ziven-u2di.forum.user-submission-option-jzwz')}
              </div>
            
              {u2diUserType0===false && u2diUserType9===false && (
                <div className="u2diUserSubmitionHint">
                  提示：此处支持无账号发布，批量发布请加入我们的 <span style="cursor:pointer;color:rgb(0, 161, 214)" onclick={()=>{app.modal.show(SiteInfoYouKePlanModal,{wrapData:wrapData,editMode:true})}}>优客计划</span>
                </div>
              )}
            </div>
          )}

          {this.viewType==="edit" && u2diUserType9===true && (
            <div style="text-align:center">
              {this.from==="info" && (
                <InfoManagementComponent targetData={this.targetData} targetDetailsData={this.targetDetailsData} editMode={true} />
              )}
              {this.from==="query" && (
                <QueryManagementComponent targetData={this.targetData} targetDetailsData={this.targetDetailsData} editMode={true} />
              )}
              <div style="padding: 20px 0px;">
                <hr style="border-top: 1px solid rgba(122,122,122,0.2);" />
              </div>
            </div>
          )}

          {(this.viewType==="edit" || this.viewType==="read") && (
            <div style="text-align:center">
              <div style="cursor:default" className={button0ClassName}>
                {app.translator.trans('ziven-u2di.forum.user-submission-option-tdwz')}
              </div>
              <div style="cursor:default;margin-left: 3px;" group="userSubmitionTypes" className={button1ClassName}>
                {app.translator.trans('ziven-u2di.forum.user-submission-option-jzwz')}
              </div>
            </div>
          )}

          {showEditButton && (
            <div style="text-align: center;padding-top: 20px;">
            {Button.component({
                style:"width: 50px;font-size: 12px;height: 24px;line-height: 0px;padding-left: 13px;margin-left: 13px;",
                disabled: this.loading,
                className: 'Button U2DiButton--gray',
                onclick: (e) => {
                  this.editMode = true;
                }
              },
              app.translator.trans('ziven-u2di.lib.edit')
            )}
            </div>
          )}

          {this.selectedType!==null && (
            <div>
              {UserSubmitType1Component.component({wrapData,editMode})}
            </div>
          )}
        </div>
      </div>
    ];
  }

  showComponent(componentType){
    if(this.selectedType!==componentType && this.viewType==="normal"){
      this.selectedType = componentType;
      m.redraw();
    }
  }
}
